
import * as React from 'react';
import imgSrc from './images/Check.png';
import { ImageIcon } from './ImageIcon';

export const IconEmojiCheck = (props: React.ImgHTMLAttributes<HTMLImageElement>) => (
  <ImageIcon src={imgSrc} {...props} />
);
